import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext'; // Descomentado
import { UserProfile } from '@/types'; // Descomentado (se necessário, mas AuthContext.user já é UserProfile)
import { supabase } from '@/lib/supabase'; // Importar supabase client
import { format } from 'date-fns'; // Para formatar a data
import { ptBR } from 'date-fns/locale'; // Para formato brasileiro

// Usar o novo APP_ID. VITE_LUDOPEDIA_APP_ID deve ser a3c0d77d6f2022c1
const LUDOPEDIA_APP_ID = import.meta.env.VITE_LUDOPEDIA_APP_ID || 'a3c0d77d6f2022c1'; 

// VITE_LUDOPEDIA_REDIRECT_URI deve ser http://localhost:5176/auth/ludopedia/callback para dev
// ou https://www.boardverso.com/auth/ludopedia/callback para prod
let redirectUriFallback = '/auth/ludopedia/callback';
if (typeof window !== 'undefined') {
  const protocol = window.location.protocol;
  let hostname = window.location.hostname;
  const port = window.location.port;
  hostname = hostname.replace(/^www\./i, ''); // Remove www. do início, case-insensitive
  const windowOriginWithoutWWW = `${protocol}//${hostname}${port ? ':' + port : ''}`;
  redirectUriFallback = `${windowOriginWithoutWWW}/auth/ludopedia/callback`;
}
const LUDOPEDIA_REDIRECT_URI = import.meta.env.VITE_LUDOPEDIA_REDIRECT_URI || redirectUriFallback;

const LUDOPEDIA_OAUTH_BASE_URL = 'https://ludopedia.com.br/oauth'; // Revertendo para /oauth como no código antigo

interface LudopediaIntegrationProps {
  // Props, se necessário
}

export const LudopediaIntegration: React.FC<LudopediaIntegrationProps> = () => {
  const { user, loading: authLoading } = useAuth(); // Usando user e authLoading do AuthContext
  const [isLoading, setIsLoading] = useState(false);
  const [lastSyncDate, setLastSyncDate] = useState<string | null>(null);
  // const [ludopediaUsername, setLudopediaUsername] = useState<string | null>(null); // Removido, usar user.ludopedia_username
  // const [isConnected, setIsConnected] = useState(false); // Removido, derivar de user.ludopedia_access_token

  // Remover Mocks
  // const mockUser = { id: 'mock-user-id' }; 
  // const [mockProfile, setMockProfile] = useState<any | null>({
  //   id: 'mock-user-id',
  //   ludopedia_user_id: null,
  //   ludopedia_access_token: null,
  //   ludopedia_username: null,
  // });
  // const user = mockUser; 
  // const profile = mockProfile; 

  // Derivar isConnected e ludopediaUsername diretamente do user do AuthContext
  const isConnected = !!user?.ludopedia_access_token;
  const ludopediaUsername = user?.ludopedia_username || null;

  // useEffect(() => {
  //   if (!authLoading && profile) { // MOCKADO: profile
  //     setIsConnected(!!profile.ludopedia_access_token);
  //     setLudopediaUsername(profile.ludopedia_username || null);
  //   }
  // }, [profile, authLoading]); // MOCKADO: profile

  // Carregar data da última sincronização do localStorage ao montar
  useEffect(() => {
    if (isConnected && user?.id) {
      const savedSyncDate = localStorage.getItem(`ludopediaLastSync_${user.id}`);
      if (savedSyncDate) {
        setLastSyncDate(savedSyncDate);
      }
    }
  }, [isConnected, user?.id]);

  const handleConnectLudopedia = () => {
    // Revertendo para a estrutura de URL que funcionava: /oauth e app_id, sem encodeURIComponent no redirect_uri
    // Certifique-se que LUDOPEDIA_APP_ID está correto (a3c0d77d6f2022c1)
    // e que LUDOPEDIA_REDIRECT_URI está exatamente como cadastrado na Ludopedia.
    const authUrl = `${LUDOPEDIA_OAUTH_BASE_URL}?app_id=${LUDOPEDIA_APP_ID}&redirect_uri=${LUDOPEDIA_REDIRECT_URI}&response_type=code&scope=colecao_leitura`;
    window.location.href = authUrl;
  };

  const handleSyncCollection = async () => {
    if (!user || !user.ludopedia_access_token) {
      alert('Por favor, conecte-se à Ludopedia primeiro.');
      return;
    }
    setIsLoading(true);
    try {
      console.log(`[FRONTEND-LUDO] Chamando a função 'ludopedia-sync-collection' para o usuário: ${user.id}`);
      const { data, error } = await supabase.functions.invoke('ludopedia-sync-collection', {
        body: { userId: user.id },
      });

      if (error) {
        // Tentar extrair uma mensagem mais amigável do erro da função, se disponível
        const functionError = (error as any).context?.body?.message || error.message;
        throw new Error(functionError || 'Falha ao sincronizar a coleção.');
      }

      const now = new Date().toISOString();
      localStorage.setItem(`ludopediaLastSync_${user.id}`, now); // Salvar com user ID para múltiplos usuários
      setLastSyncDate(now);
      // A função retorna { success: true, message: '...' } ou { error: true, message: '...' }
      // Acessar a mensagem de data.message
      alert(data.message || 'Coleção sincronizada com sucesso!');
      // Idealmente, o AuthContext deveria ter uma função para recarregar o perfil completo
      // auth.refreshUserProfile(); 
    } catch (error: any) { // Ajustado para any para melhor tratamento de erros
      console.error('Erro ao sincronizar coleção:', error);
      // O erro já deve ser uma string aqui, devido ao tratamento acima ou ser um erro de rede
      alert(`Erro: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDisconnectLudopedia = async () => {
    if (!user) return;
    setIsLoading(true);
    try {
      console.log(`[FRONTEND-LUDO] Chamando a função 'ludopedia-disconnect' para o usuário: ${user.id}`);
      const { data, error } = await supabase.functions.invoke('ludopedia-disconnect', {
        body: { userId: user.id },
      });

      if (error) {
        const functionError = (error as any).context?.body?.message || error.message;
        throw new Error(functionError || 'Falha ao desconectar.');
      }
      localStorage.removeItem(`ludopediaLastSync_${user.id}`); // Remover data de sinc ao desconectar
      setLastSyncDate(null);
      // A função retorna { success: true, message: '...' } ou { error: true, message: '...' }
      alert(data.message || 'Desconectado da Ludopedia com sucesso. A página pode precisar ser recarregada para refletir todas as mudanças.');
      // Para que a UI atualize o estado de `isConnected` e `ludopediaUsername`,
      // a função `updateProfile` do AuthContext deve ser chamada aqui para limpar os campos da ludopedia
      // ou um refresh completo do usuário. Por enquanto, o AuthContext não tem uma função `refreshProfile` fácil.
      // A maneira mais simples de forçar a atualização é chamar `updateProfile` com os campos nulos.
      // Assumindo que 'ludopedia-disconnect' no backend já limpou os dados no banco.
      // user.updateProfile({ ludopedia_access_token: null, ludopedia_user_id: null, ludopedia_username: null });
      // A mensagem acima já instrui o usuário a recarregar, o que buscará o novo estado do AuthContext.
    } catch (error: any) {
      console.error('Erro ao desconectar da Ludopedia:', error);
      alert(`Erro: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  if (authLoading) {
    return <div className="p-4 text-center text-gray-700 dark:text-gray-300">Carregando informações de integração...</div>;
  }

  return (
    <div className="p-4 border rounded-lg shadow-sm bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700">
      <h2 className="text-xl font-semibold mb-3 text-gray-800 dark:text-gray-100">Integração com Ludopedia</h2>
      {isConnected ? (
        <div>
          <p className="mb-1 text-gray-700 dark:text-gray-300">
            Conectado como: <span className="font-medium text-gray-900 dark:text-gray-100">{ludopediaUsername || 'Usuário Ludopedia'}</span>
          </p>
          {lastSyncDate && (
            <p className="text-xs text-gray-500 dark:text-gray-400 mb-2">
              Última sincronização: {format(new Date(lastSyncDate), "dd/MM/yyyy 'às' HH:mm", { locale: ptBR })}
            </p>
          )}
          <div className="flex space-x-2">
            <Button onClick={handleSyncCollection} disabled={isLoading || !user?.ludopedia_access_token}>
              {isLoading ? 'Sincronizando...' : 'Sincronizar Coleção'}
            </Button>
            <Button variant="outline" onClick={handleDisconnectLudopedia} disabled={isLoading || !user?.ludopedia_access_token}>
              {isLoading ? 'Desconectando...' : 'Desconectar'}
            </Button>
          </div>
        </div>
      ) : (
        <div>
          <p className="mb-2 text-gray-700 dark:text-gray-300">Conecte sua conta da Ludopedia para sincronizar sua coleção de jogos.</p>
          <Button onClick={handleConnectLudopedia} disabled={isLoading}>
            {isLoading ? 'Conectando...' : 'Conectar com Ludopedia'}
          </Button>
        </div>
      )}
      <p className="text-xs text-gray-500 dark:text-gray-400 mt-4">
        Ao conectar, você nos autoriza a acessar sua coleção de jogos na Ludopedia.
        {/* Atualizado para usar user do AuthContext */}
        Nós usaremos seu ID de usuário da Ludopedia ({user?.ludopedia_user_id || 'não conectado'}) e um token de acesso para buscar seus jogos.
      </p>
    </div>
  );
}; 